import {
  PortfolioHedgeManagerAllocation,
  PortfolioHedgeManagerAllocations,
  PortfolioHedgeManagerAllocationStrategy,
} from '@models';
import { PortfolioDTO, PortfolioHedgeManagerAllocationDTO } from '@types';
import { formatPercentage } from '@utils/text/number-utils';
import { MapperFactory } from '../mapper-factory';
import { Mapper, MapperParams } from '../type.mapper';
import orderBy from 'lodash/orderBy';
import { getFirstNonEmptyProp, parseStdNumber } from '../mapper.utils';

// tslint:disable-next-line:max-line-length
// example fund: https://en-us.staging.ftsites.com/investments/options/mutual-funds/products/18120/A/franklin-k-2-alternative-strategies-fund/FAAAX#portfolio
export class ManagerAllocationMapper extends Mapper<PortfolioHedgeManagerAllocations> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(portfolioDto: PortfolioDTO): PortfolioHedgeManagerAllocations {
    const data: PortfolioHedgeManagerAllocationDTO[] =
      portfolioDto.hedgemanagerallocation;

    // if no data, return null
    if (!data || data.length === 0) {
      return null;
    }
    const updateFrequency: string = getFirstNonEmptyProp(data, 'frequency');
    const allocations: PortfolioHedgeManagerAllocations = {
      strategies: orderBy(
        data
          .filter(
            (obj: PortfolioHedgeManagerAllocationDTO) => obj.mngrroster === ''
          )
          .map(
            (
              obj: PortfolioHedgeManagerAllocationDTO
            ): PortfolioHedgeManagerAllocationStrategy => ({
              strategy: obj.mngrrosterstrtgy,
              totalAllocation: formatPercentage(obj.allocation),
              totalAllocationStd: parseStdNumber(obj.allocationstd),
              allocations: [],
            })
          ),
        ['totalAllocationStd'],
        ['desc']
      ),
      asOfDate: getFirstNonEmptyProp(data, 'asofdate'),
      updateFrequency:
        updateFrequency &&
        this.mapperParams.translateService.instant(
          `products.updated-${updateFrequency}`
        ),
    };

    allocations.strategies.forEach(
      (strategy) =>
        (strategy.allocations = orderBy(
          data
            .filter(
              (obj: PortfolioHedgeManagerAllocationDTO) =>
                obj.mngrrosterstrtgy === strategy.strategy &&
                obj.mngrroster !== ''
            )
            .map(
              (
                obj: PortfolioHedgeManagerAllocationDTO
              ): PortfolioHedgeManagerAllocation => ({
                managerRoster: obj.mngrroster,
                allocation: formatPercentage(obj.allocation),
                allocationStd: parseStdNumber(obj.allocationstd),
              })
            ),
          ['allocationStd'],
          ['desc']
        ))
    );

    return allocations;
  }
}
